<template>
    <div class="global-search-wrap">
        搜索
    </div>
</template>
<script>
export default {
    name: "GlobalSearch",
    data() {
        return {

        }
    }
}
</script>
